'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	baseUrl: 'https://api.particle.io',
	clientSecret: 'particle-api',
	clientId: 'particle-api',
	tokenDuration: 7776000 };
module.exports = exports['default'];
//# sourceMappingURL=Defaults.js.map